import React from 'react';

import ActionLarge from './action-large';
import ActionMedium from './action-medium';
import ActionSmall from './action-small';
import FormattedText from './formatted-text';
import Header1 from './header-1';
import Header2 from './header-2';
import Header3 from './header-3';
import P1 from './p-1';
import P2 from './p-2';
import P3 from './p-3';

export {
  Header1,
  Header2,
  Header3,
  P1,
  P2,
  P3,
  ActionSmall,
  ActionMedium,
  ActionLarge,
  FormattedText,
};

/**
 * This is a mock component - to parse properly name in styleguide
 * @param props
 */
const Typography: React.FC<React.PropsWithChildren> = (props) => <>{props.children}</>;

export default Typography;
